export default {
  africa:'Africa',
  america:'America',
  asia:'Asia',
  australia: 'Australia',
  bahrain: 'Bahrain',
  brasil: 'Brasil',
  'canada (en)': 'Canada (EN)',
  'canada (fr)': 'Canada (FR)',
  carousel_promotion: 'Promotions header carousel',
  carousel_promotion_role: 'carousel',
  chatbot_button: 'Chat with us',
  chile: 'Chile',
  cms_shop_now: 'Shop Now',
  code_copied: 'Copied to clipboard',
  colombia: 'Colombia',
  contact_us_how: 'How do you want to contact us?',
  contact_us_new_order: 'New Order Creation',
  contact_us_order_cancellation: 'Order cancellation and modification',
  contact_us_order_cancellation_modification: 'Order cancellation and modification',
  contact_us_order_creation: 'Order Creation Support',
  contact_us_order_lost: 'Order lost, damaged or not received',
  contact_us_order_status: 'Order status',
  contact_us_order_status_shipping: 'Order status and shipping information',
  contact_us_other: 'Other',
  contact_us_prescription: 'Prescription and verification process',
  contact_us_product_information: 'Product information',
  contact_us_purchase: 'Purchase assistance and order issue',
  contact_us_refund: 'Refund, replacement and return status',
  contact_us_refund_boris: 'Return and refund status',
  contact_us_sales: 'Group Sales',
  contact_us_select: 'Select a topic',
  chatbot_message_us:'Message Us',
  contact_us_smart_glasses_enquiries: 'AI Glasses inquiries',
  contact_us_store: 'Store inquiries',
  contact_us_title: 'Why do you need help?',
  contact_us_warranty_assistance: 'Warranty Assistance',
  contact_us_warranty_request: 'Warranty Request',
  contact_us_boris: 'Exchange in store',
  copy_code: 'Copy code',
  country_locale: 'US',
  country_name: 'United States',
  country_title: 'Location',
  cs_description: 'If you wish to ship to another location, please select your location below. Be aware that changing your location while shopping will remove all items from the Shopping Bag',
  cs_invalid_card_number: 'Please enter a valid 16 digit gift card number',
  cs_invalid_pin_number: 'Please enter a valid 8 digit PIN number',
  cs_shipping_to: 'Shipping to',
  current_price: 'Current Price',
  egypt: 'Egypt',
  europe: 'Europe',
  france: 'France',
  germany: 'Germany',
  'hong kong (china)': 'Hong Kong (China)',
  india: 'India',
  indonesia: 'Indonesia',
  jordan: 'Jordan',
  kuwait: 'Kuwait',
  lebanon: 'Lebanon',
  logged_in: 'You\'re logged in!',
  logged_in_cta: 'Go to my account',
  logged_in_description: 'We’ve sent you an email to confirm your account. If you can’t find the email, please resend it from the profile.',
  ma_harg_card_number: 'Card number',
  ma_harg_pin_number: 'Pin number',
  ma_hnu_check_balance_gc: 'Check balance',
  ma_hnu_your_balance_gc: 'Your balance is {0} $',
  malaysia: 'Malaysia',
  mexico: 'Mexico',
  'middle east': 'Middle East',
  morocco: 'Morocco',
  netherlands: 'Netherlands',
  'new zealand': 'New Zealand',
  next: 'Next promotion',
  oceania: 'Oceania',
  old_price: 'Old Price',
  oman: 'Oman',
  pdp_you_might_interested: 'You might also like',
  pdp_you_might_interested_accessories: 'Perfect accessories',
  pdp_you_might_interested_recentl: 'Recently viewed',
  previous: 'Previous promotion',
  peru: 'Perù',
  portugal: 'Portugal',
  promobar_ends_in: 'ENDS IN',
  qatar: 'Qatar', 'saudi arabia': 'Saudi Arabia',
  singapore: 'Singapore', 'south africa': 'South Africa',
  spain: 'Spain',
  thailand: 'Thailand',
  turkey: 'Turkey', 'united arab emirates': 'United Arab Emirates', 'united kingdom': 'United Kingdom', 'united states': 'United States',
  rtr_rotate_text: 'ROTATE AND MOVE AROUND',
  new_tab: 'opens in new tab',
}
